import { render, staticRenderFns } from "./SupportBtn.vue?vue&type=template&id=30839717&"
import script from "./SupportBtn.vue?vue&type=script&lang=js&"
export * from "./SupportBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SupportBtn.vue"
export default component.exports